import { IntegrationTypesActionTypes } from './constants';

type IntegrationTypesAction = { type: string, payload: {} | string };

export const integrationTypesApiResponseSuccess = (actionType: string, data: any): IntegrationTypesAction => ({
    type: IntegrationTypesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const integrationTypesApiResponseError = (actionType: string, error: string): IntegrationTypesAction => ({
    type: IntegrationTypesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAllIntegrationTypes = (query): IntegrationTypesAction => ({
    type: IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES,
    payload: { query },
});

export const integrationTypesResetState = (): IntegrationTypesAction => ({
    type: IntegrationTypesActionTypes.RESET_STATE,
    payload: {},
});

export const integrationTypesResetAllErrors = (): IntegrationTypesAction => ({
    type: IntegrationTypesActionTypes.RESET_ALL_ERRORS,
    payload: {},
});